import React from 'react';
import { get } from 'lodash';
import { CS_ROLE_NAME, productInitFields } from '@utils/constants';
import { NameCell, ApplicationDropdown, DashboardCell } from './components';

const appDefaultDashboard = {
  p4: 'Quality',
  ei: productInitFields.EI.TAB_TITLE_TRENDS,
  ai: productInitFields.AI.TAB_TITLE_TRENDS,
  app: productInitFields.APP.TAB_TITLE_TRENDS,
  ci: 'Overview',
  precision: 'Policies',
  si: 'Analytics',
  vi: 'Dashboard',
  community: 'Community',
  plm: 'Application Manager',
  touchstone: 'Touchstone',
  mds: 'Metadata Management',
  advi: 'Audience',
};

const getDashboardName = (name: string, app: string, role: string) => {
  if (role === CS_ROLE_NAME && ['ei', 'ai', 'precision'].includes(app)) {
    return 'Viewers';
  }
  switch (name) {
  case 'noc':
  case 'real-time':
    return 'Real-Time';
  case 'trends':
    return app === 'ei' ? productInitFields.EI.TAB_TITLE_TRENDS : productInitFields.AI.TAB_TITLE_TRENDS;
  case '':
    return appDefaultDashboard[app];
  default:
    return name;
  }
};

const columns = [
  {
    title: 'Account Name',
    dataKey: 'customer.name',
    key: 'customer.name',
    width: 300,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: name, rowData: { id, primary } }) => <NameCell profileId={id} name={name} primary={primary} />,
  },
  {
    title: 'User Role',
    dataKey: 'role',
    key: 'role',
    width: 150,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Time Zone',
    dataKey: 'customer.tzName',
    key: 'customer.tzName',
    width: 150,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Customer Key',
    dataKey: 'customer.apiKey',
    key: 'customer.apiKey',
    width: 500,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Default Application',
    dataKey: 'defaultApp.app',
    key: 'defaultApp.app',
    width: 250,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: app, rowData: profile }) => <ApplicationDropdown profileId={profile.id} app={app} profile={profile} />,
  },
  {
    title: 'Default Dashboard',
    dataKey: 'defaultApp.landing.name',
    key: 'defaultApp.landing.name',
    width: 400,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: name, rowData }) => <DashboardCell dashboard={(getDashboardName(name, get(rowData, 'defaultApp.app'), get(rowData, 'role')))} />,
  },
];

export default columns;
